import { forwardRef } from 'react'

import { Button } from '@mantine/core'
import { createLink, type LinkComponent } from '@tanstack/react-router'
import * as _ from 'lodash-es'

type ButtonProps = Omit<ReactProps<typeof Button<'a'>>, 'href'>

const MantineLinkButton = forwardRef<HTMLAnchorElement, ButtonProps>(
  function MantineLinkButton(props, ref) {
    return <Button component="a" ref={ref} {...props} />
  },
)

const CreatedLinkComponent = createLink(MantineLinkButton)

export const LinkButton: LinkComponent<typeof MantineLinkButton> = (props) => {
  return <CreatedLinkComponent preload="intent" {...props} />
}
